import { ChevronLeft, ChevronRight } from '@mui/icons-material'
import { Box, IconButton, Typography } from '@mui/material'
import CustomSelect from '../../../../v2/general/CustomSelect/CustomSelect'

interface ServicesPaginationProps {
	currentPage: number
	totalPages: number
	totalServices: number
	rowsPerPage: number
	onChangeRowsPerPage: (newRowsPerPage: 5 | 10 | 15) => void
	onNextPage: () => void
	onPreviousPage: () => void
}

export default function ServicesPagination({
	currentPage,
	totalPages,
	totalServices,
	rowsPerPage,
	onChangeRowsPerPage,
	onNextPage,
	onPreviousPage,
}: ServicesPaginationProps) {
	const showingFrom = (currentPage - 1) * rowsPerPage + 1
	const showingTo = Math.min(currentPage * rowsPerPage, totalServices)

	return (
		<Box
			sx={{
				display: 'flex',
				padding: '2px 0px',
				justifyContent: 'flex-end',
				alignItems: 'center',
				gap: '26px',
				alignSelf: 'stretch',
			}}
		>
			<Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
				<Typography
					variant='body2'
					sx={{
						fontWeight: 400,
						fontFamily: 'var(--font-family)',
						fontSize: '11px',
						color: 'var(--primary-light)',
					}}
				>
					Linhas por página
				</Typography>
				<CustomSelect
					fullWidth={false}
					size='small'
					variant='outlined'
					label=''
					value={rowsPerPage.toString()}
					onChange={event => onChangeRowsPerPage(Number((event.target as HTMLInputElement).value) as 5 | 10 | 15)}
					options={[
						{ label: '5', value: '5' },
						{ label: '10', value: '10' },
						{ label: '15', value: '15' },
					]}
					sx={{
						minWidth: '38px',
						'& .MuiOutlinedInput-notchedOutline': {
							border: 'none',
						},
						'& .MuiSelect-select': {
							paddingInline: '0px 5px !important',
							paddingBlock: '5px',
							width: '2ch',
							fontFamily: 'var(--font-family)',
							fontSize: '11px',
						},
						'& .MuiSvgIcon-root': {
							fontSize: '16px',
						},
					}}
				/>
			</Box>
			<Typography
				variant='body2'
				sx={{ fontWeight: 400, fontFamily: 'var(--font-family)', fontSize: '11px', color: 'var(--primary-dark)' }}
			>
				{showingFrom} - {showingTo} de {totalServices}
			</Typography>
			<Box>
				<IconButton
					onClick={onPreviousPage}
					disabled={currentPage === 1}
					size='small'
					sx={{
						borderRadius: 0,
						padding: '8px',
					}}
				>
					<ChevronLeft sx={{ color: currentPage === 1 ? 'var(--primary-light)' : 'var(--primary)' }} />
				</IconButton>
				<IconButton
					onClick={onNextPage}
					disabled={currentPage === totalPages}
					sx={{
						borderRadius: 0,
						padding: '8px',
					}}
				>
					<ChevronRight sx={{ color: currentPage === totalPages ? 'var(--primary-light)' : 'var(--primary)' }} />
				</IconButton>
			</Box>
		</Box>
	)
}
